// 手機card product影片在頁面自動播放、滑掉停止202603-San - 202607-San優化again
document.addEventListener('DOMContentLoaded', function () {
  const lazyVideoCards = document.querySelectorAll('[data-video-lazy]');

  /**
   * 將 template 內的影片插入商品卡片。
   * 每張卡片只執行一次，避免重複載入影片。
   */
  const loadVideo = (card) => {
    if (!card || card.dataset.videoLoaded === 'true') return;

    const template = card.querySelector('template');
    if (!template) return;

    const clone = template.content.cloneNode(true);
    card.appendChild(clone);
    card.dataset.videoLoaded = 'true';

    const video = card.querySelector('video');
    if (!video) return;

    // 提高手機自動播放成功率
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;

    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    /**
     * 建議讓影片積極預載。
     * 由於此時距離畫面約 800px，能提早建立 buffer。
     */
    video.preload = 'auto';
    video.setAttribute('preload', 'auto');

    const markReady = () => {
      card.classList.add('is-video-ready');
    };

    video.addEventListener('loadeddata', markReady, { once: true });
    video.addEventListener('canplay', markReady, { once: true });

    /**
     * 先不呼叫 video.play()。
     * 這個函式現在只負責載入，不負責播放。
     */
    video.load();
  };

  /**
   * 播放商品卡片影片。
   */
  const playVideo = (card) => {
    if (!card) return;

    const video = card.querySelector('video');
    if (!video) return;

    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;

    const playPromise = video.play();

    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {
        // 自動播放被瀏覽器暫時拒絕時不顯示錯誤
      });
    }
  };

  /**
   * 暫停商品卡片影片。
   * 不移除 src，也不重新 load，避免使用者滑回來時重新下載。
   */
  const pauseVideo = (card) => {
    if (!card) return;

    const video = card.querySelector('video');

    if (video && !video.paused) {
      video.pause();
    }
  };

  /**
   * 第一個 observer：
   * 商品距離畫面上下約 800px 時，只開始載入影片。
   */
  const loadObserver = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        loadVideo(entry.target);

        // 影片只需載入一次，不必繼續觀察載入狀態
        observer.unobserve(entry.target);
      });
    },
    {
      root: null,
      rootMargin: '800px 0px',
      threshold: 0
    }
  );

  /**
   * 第二個 observer：
   * 商品真正進入畫面 20% 後播放，滑出後暫停。
   */
  const playObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const card = entry.target;

        if (entry.isIntersecting) {
          /**
           * 極快滑動時，影片可能還沒有被 loadObserver 載入。
           * 因此這裡保留 loadVideo 作為保險。
           */
          loadVideo(card);
          playVideo(card);
        } else {
          pauseVideo(card);
        }
      });
    },
    {
      root: null,
      rootMargin: '0px',
      threshold: 0.2
    }
  );

  lazyVideoCards.forEach((card) => {
    loadObserver.observe(card);
    playObserver.observe(card);
  });
});